import { writable } from 'svelte/store';
import random from './check_random/random'

export const uqn = writable(random());
//export const selected = writable([1, 2, 3, 4, 5, 6]);
